// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** FloatingChartBar visuals + positioning (auto-hide: floating-chart-bar.css). */
.Spo3f7SP33aAdjOZ303V {
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  max-width: 320px;
  overflow: hidden;
  box-sizing: border-box;
  transition: max-width 0.2s ease, height 0.2s ease, opacity 0.2s ease, border-radius 0.2s ease, padding 0.2s ease;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  user-select: none;
  white-space: nowrap;
}

.OAdtIGGy72MFiMcs7b6S {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  flex-shrink: 0;
}

.OAdtIGGy72MFiMcs7b6S:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.OAdtIGGy72MFiMcs7b6S:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.CaxdF6n_xpg1e2qMGBPG {
  color: var(--vnsc-primary, #2962ff);
}

.KupjXwu3JWDoQaq_vBmM {
  width: 1px;
  height: 18px;
  background: var(--vnsc-border, #2a2a2a);
  margin: 0 4px;
  flex-shrink: 0;
}

.ftxasW1WTs5uY4lOeMva {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 24px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  flex-shrink: 0;
}

/* A+B7 idle: flat stadium pill. hover:hover wrap (A1) keeps touch expanded.
   :not(:focus-within) keeps Tab expanding the bar (opacity, never display:none).
   Grip is absolutely centered: flex auto-margins collapse to 0 under overflow,
   which left the dots off-center in the circle variant — absolute centering is exact. */
@media (hover: hover) {
  .Spo3f7SP33aAdjOZ303V:not(:hover):not(:focus-within) { max-width: 40px; height: 18px; padding: 1px 8px; border-radius: 13px; opacity: 0.85; }
  .Spo3f7SP33aAdjOZ303V:not(:hover):not(:focus-within) > :not(.ftxasW1WTs5uY4lOeMva) { opacity: 0; }
  .Spo3f7SP33aAdjOZ303V:not(:hover):not(:focus-within) > .ftxasW1WTs5uY4lOeMva { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); height: 14px; }
  .Spo3f7SP33aAdjOZ303V:not(:hover):not(:focus-within) > .ftxasW1WTs5uY4lOeMva svg { width: 12px; height: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/floating-chart-bar.module.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gHAAgH;EAChH,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,yDAAyD;EACzD,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;wFAGwF;AACxF;EACE,uDAAsC,eAAe,EAAE,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,aAAa,EAAE;EAC3H,qFAAoD,UAAU,EAAE;EAChE,+EAA8C,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE,gCAAgC,EAAE,YAAY,EAAE;EACvI,mFAAkD,WAAW,EAAE,YAAY,EAAE;AAC/E","sourcesContent":["/** FloatingChartBar visuals + positioning (auto-hide: floating-chart-bar.css). */\r\n.bar {\r\n  position: absolute;\r\n  bottom: 32px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 50;\r\n  max-width: 320px;\r\n  overflow: hidden;\r\n  box-sizing: border-box;\r\n  transition: max-width 0.2s ease, height 0.2s ease, opacity 0.2s ease, border-radius 0.2s ease, padding 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  padding: 4px 8px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\r\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: none;\r\n  border-radius: 3px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.btn:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btnActive {\r\n  color: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.separator {\r\n  width: 1px;\r\n  height: 18px;\r\n  background: var(--vnsc-border, #2a2a2a);\r\n  margin: 0 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.grip {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 24px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* A+B7 idle: flat stadium pill. hover:hover wrap (A1) keeps touch expanded.\r\n   :not(:focus-within) keeps Tab expanding the bar (opacity, never display:none).\r\n   Grip is absolutely centered: flex auto-margins collapse to 0 under overflow,\r\n   which left the dots off-center in the circle variant — absolute centering is exact. */\r\n@media (hover: hover) {\r\n  .bar:not(:hover):not(:focus-within) { max-width: 40px; height: 18px; padding: 1px 8px; border-radius: 13px; opacity: 0.85; }\r\n  .bar:not(:hover):not(:focus-within) > :not(.grip) { opacity: 0; }\r\n  .bar:not(:hover):not(:focus-within) > .grip { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); height: 14px; }\r\n  .bar:not(:hover):not(:focus-within) > .grip svg { width: 12px; height: 12px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `Spo3f7SP33aAdjOZ303V`,
	"btn": `OAdtIGGy72MFiMcs7b6S`,
	"btnActive": `CaxdF6n_xpg1e2qMGBPG`,
	"separator": `KupjXwu3JWDoQaq_vBmM`,
	"grip": `ftxasW1WTs5uY4lOeMva`
};
export default ___CSS_LOADER_EXPORT___;
